import React from "react";

const getCloseModalIcon = (color = "#334455", size = "16") => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 2L14 13.9395" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path
      d="M14.0012 2.00101L2.03125 14.001"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default getCloseModalIcon;
